import React from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'

import {
  BROWSE_NEON,
  BROWSE_RENTALS,
  THEME_OPTIONS
} from '../../constants'
import Button from '../button'
import styles from './carousel-empty-my-rentals.css'

function CarouselEmptyMyRentals({ theme }) {
  const history = useHistory()
  const CTA = theme === THEME_OPTIONS.light
    ? BROWSE_NEON
    : BROWSE_RENTALS

  const onButtonClick = () => {
    history.push(CTA.url)
  }

  return (
    <div className={styles.carouselEmpty}>
      <p>There&apos;s nothing here yet!</p>
      <p>When you rent a movie it will appear here, ready to watch on any device.</p>

      <div className={styles.buttonsWrapper}>
        <Button
          text={CTA.label}
          onClick={onButtonClick}
        />
      </div>
    </div>
  )
}

CarouselEmptyMyRentals.propTypes = {
  theme: PropTypes.string.isRequired
}

export default CarouselEmptyMyRentals
